import React from 'react';
import { AvMessagePopover } from '@fabric-ui/components';
import { InfoFull } from '@fabric-ui/icons/colorful';
import { flex } from '@fabric-ui/theme';
import { Box, Typography } from '@mui/material';
import { AgentTileHeadingProps } from './types';

const AgentTileHeading = ({ title, infoMessage = '' }: AgentTileHeadingProps) => (
  <Box sx={{ ...flex.row, gap: '8px' }}>
    <Typography sx={{ fontSize: '14px', mb: 2, color: 'var(--color-content-base-tertiary)' }} variant="h2">
      {title}
    </Typography>
    {infoMessage && <AvMessagePopover message={infoMessage} icon={<InfoFull />} asTooltip disableInteractive={false} />}
  </Box>
);
export default React.memo(AgentTileHeading);
